export const FETCH_SALARY_SCALE = 'FETCH_SALARY_SCALE';
export const FETCH_SALARY_SCALE_SUCCESS = 'FETCH_SALARY_SCALE_SUCCESS';
export const FETCH_SALARY_SCALE_FAILURE = 'FETCH_SALARY_SCALE_FAILURE';

export const SAVE_SALARY_SCALE = 'SAVE_SALARY_SCALE';
export const SAVE_SALARY_SCALE_SUCCESS = 'SAVE_SALARY_SCALE_SUCCESS';
export const SAVE_SALARY_SCALE_FAILURE = 'SAVE_SALARY_SCALE_FAILURE';

export const CHANGE_SALARY_SCALE_STATUS = 'CHANGE_SALARY_SCALE_STATUS';
export const CHANGE_SALARY_SCALE_STATUS_SUCCESS = 'CHANGE_SALARY_SCALE_STATUS_SUCCESS';
export const CHANGE_SALARY_SCALE_STATUS_FAILURE = 'CHANGE_SALARY_SCALE_STATUS_FAILURE';
